/**
 * http / https スキームのみ許可し、javascript: 等の危険なスキームを拒否する。
 * 管理画面で入力された URL（ポップアップのリンク・キャンペーンの redirectUrl）の検証に使う。
 */
export const isSafeRedirectUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url)
    return parsed.protocol === 'http:' || parsed.protocol === 'https:'
  } catch {
    return false
  }
}
